export default "__VITE_ASSET__BQHJNW9t__"